import FacebookIcon from '@mui/icons-material/FacebookRounded'
import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import YouTubeIcon from '@mui/icons-material/YouTube'
import { Box } from '@mui/material'
import { Link } from '@rentspree/component-2023.components.atoms.link'
import { Typography } from '@rentspree/component-2023.components.atoms.typography'

import { TwitterXIcon } from 'constant/icons'

import styles from './footer-follow-us.module.scss'

export const FooterFollowUs: React.FC = () => (
  <Box className={styles.footerFollowUsContainer}>
    <Typography className={styles.footerFollowUsText} variant="body-medium">
      Follow us
    </Typography>
    <Box className={styles.footerFollowUsLinksContainer}>
      <Link
        color="black"
        href="https://www.facebook.com/rentspree"
        data-testid="follow-us-link-facebook"
        target="_blank"
        rel="noreferrer"
      >
        <FacebookIcon />
      </Link>
      <Link
        color="black"
        href="https://www.instagram.com/rentspree/"
        data-testid="follow-us-link-instagram"
        target="_blank"
        rel="noreferrer"
      >
        <InstagramIcon />
      </Link>
      <Link
        color="black"
        href="https://twitter.com/rentspree"
        data-testid="follow-us-link-twitter-x"
        target="_blank"
        rel="noreferrer"
      >
        <img src={TwitterXIcon} alt="Twitter X Icon" width={24} height={24} />
      </Link>
      <Link
        color="black"
        href="https://www.linkedin.com/company/rentspree"
        data-testid="follow-us-link-linkedin"
        target="_blank"
        rel="noreferrer"
      >
        <LinkedInIcon />
      </Link>
      <Link
        color="black"
        href="https://www.youtube.com/c/rentspree"
        data-testid="follow-us-link-youtube"
        target="_blank"
        rel="noreferrer"
      >
        <YouTubeIcon />
      </Link>
    </Box>
  </Box>
)
